import { BaseResponse, PaginationResponse } from "src/models/BaseModel";
import { Product, UpdateProductBody } from "src/models/ProductModel";
import { PrivateApi } from "./BaseApi";

export const productsApi = PrivateApi.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query<
      PaginationResponse<Product[]>,
      Record<string, any>
    >({
      query: (body) => ({
        url: "Dashboard/GetItems",
        method: "POST",
        body,
      }),
      providesTags: ["Products"],
    }),
    updateProduct: builder.mutation<BaseResponse<Product>, UpdateProductBody>({
      invalidatesTags: ["Products"],
      query: (body) => ({
        url: "Dashboard/UpdateItem",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetProductsQuery, useUpdateProductMutation } = productsApi;
